(() => {
  const config = window.stickyHippoProductUi || {};
  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim();

  const createFallbackRating = () => {
    const wrapper = document.createElement('div');
    const rating = config.fallbackRating || '4.9';
    const count = config.fallbackRatingCount || '824';

    wrapper.className = 'rating-wrapper stickyhippo-rating-fallback';
    wrapper.dataset.stickyhippoRating = 'fallback';
    wrapper.innerHTML = `
      <div class="rating" role="img" aria-label="${config.fallbackRatingLabel || `${rating} out of 5.0 stars`}">
        <span aria-hidden="true" class="rating-star" style="--rating: 4; --rating-max: 5.0; --rating-decimal: 1;"></span>
      </div>
      <p class="rating-text caption"><span aria-hidden="true">${rating} / 5.0</span></p>
      <p class="rating-count caption">
        <span aria-hidden="true">(${count})</span>
        <span class="visually-hidden">${count} ${config.totalReviewsLabel || 'total reviews'}</span>
      </p>
    `;

    return wrapper;
  };

  const ensureRating = (container) => {
    const nativeRating = container.querySelector('.rating-wrapper:not([data-stickyhippo-rating="fallback"])');
    const fallback = container.querySelector('[data-stickyhippo-rating="fallback"]');

    if (nativeRating) {
      fallback?.remove();
      return;
    }

    if (fallback) return;

    const title = container.querySelector('.product__title');
    if (title) title.before(createFallbackRating());
  };

  const repairShippingText = (taxNote) => {
    const originalText = taxNote.dataset.originalPriceText;
    if (!originalText || normalize(taxNote.textContent) === normalize(originalText)) return;

    let replacement = taxNote.parentElement?.querySelector('.stickyhippo-shipping-note');

    if (!replacement) {
      replacement = document.createElement('div');
      replacement.className = 'product__tax caption rte stickyhippo-shipping-note';
      taxNote.after(replacement);
    }

    replacement.innerHTML = config.shippingPolicyHtml || originalText;
    taxNote.hidden = true;
    taxNote.setAttribute('aria-hidden', 'true');
  };

  const refreshProductInfo = () => {
    document.querySelectorAll('main .product__info-container').forEach(ensureRating);
    document.querySelectorAll('main .product__tax[data-original-price-text]').forEach(repairShippingText);
  };

  let refreshQueued = false;
  const queueRefresh = () => {
    if (refreshQueued) return;
    refreshQueued = true;
    window.requestAnimationFrame(() => {
      refreshQueued = false;
      refreshProductInfo();
    });
  };

  refreshProductInfo();

  const observer = new MutationObserver(queueRefresh);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();
